import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da0khi03256a3o8kots0";

export default function Newsletter() {
  const [formError, setFormError] = useState("");
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honeypot = (data.get("website_alt") as string)?.trim();
    if (honeypot) {
      setSuccess(true);
      setFormError("");
      form.reset();
      return;
    }
    data.delete("website_alt");

    setFormError("");
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" },
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } =
        {};
      try {
        parsed = responseText ? JSON.parse(responseText) : {};
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      if (res.ok && parsed?.code === "OK" && !serverMsg.includes("spam")) {
        setSuccess(true);
        form.reset();
      } else {
        setFormError(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setFormError("网络异常，请稍后再试。");
    }
  }

  return (
    <section className="relative overflow-hidden py-14 md:py-20">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20ink%20wash%20background%20with%20soft%20flowing%20paper%20waves%20and%20book%20motifs%2C%20deep%20coral%20and%20cream%20palette%2C%20elegant%20editorial%20illustration%2C%20cozy%20reading%20atmosphere&width=1800&height=520&seq=newsletter-bg&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-700/85 to-accent-600/85"></div>
      </div>
      <div className="relative mx-auto max-w-3xl px-4 text-center md:px-6">
        <h2 className="font-heading text-2xl font-extrabold text-background-50 md:text-3xl">
          订阅漫天堂，好作品不错过
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
          每周精选人气新番与高分推荐，第一时间推送到你的邮箱。放心，我们不会打扰你。
        </p>
        <form
          data-readdy-form="newsletter-signup"
          id="newsletter-signup"
          onSubmit={handleSubmit}
          className="mx-auto mt-7 flex max-w-lg flex-col gap-3 sm:flex-row"
          noValidate
        >
          <label htmlFor="newsletter-email" className="sr-only">
            邮箱地址
          </label>
          <input
            id="newsletter-email"
            type="email"
            name="email"
            required
            placeholder="请输入你的邮箱"
            autoComplete="email"
            className="min-w-0 flex-1 rounded-full border border-background-50/30 bg-background-50/15 px-5 py-3 text-sm text-background-50 placeholder:text-background-100/70 backdrop-blur focus:border-background-50/60 focus:outline-none"
          />
          <input
            type="text"
            name="website_alt"
            autoComplete="off"
            tabIndex={-1}
            aria-hidden="true"
            readOnly
            className="antispam-alt"
          />
          <button
            type="submit"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-accent-100"
          >
            立即订阅
          </button>
        </form>
        {success && (
          <p className="mt-4 text-sm font-medium text-accent-100">
            订阅成功，感谢你的关注！我们会定期给你推送好作品。
          </p>
        )}
        {formError && (
          <p className="mt-4 text-sm font-medium text-background-50">{formError}</p>
        )}
      </div>
    </section>
  );
}